import React from 'react';
import { Link } from 'react-router-dom';

const ActionButton = ({ variant = 'primary', size = 'sm', children, to, href, className = '', ...rest }) => {
  const classes = [
    'action-btn',
    `action-btn--${variant}`,
    `action-btn--${size}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  if (to) {
    return (
      <Link to={to} className={classes} {...rest}>
        {children}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} className={classes} {...rest}>
        {children}
      </a>
    );
  }

  return (
    <button type="button" className={classes} {...rest}>
      {children}
    </button>
  );
};

export default ActionButton;
